/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-danger-with-children */
import Link from 'next/link'
import { Button, Col, Row } from 'react-bootstrap'
import Image from 'next/image'
import BusinessSpeedImage from '@assets/img/business-speed.webp'

import styles from './BusinessSpeed.module.scss'

export type BusinessSpeedProps = {
    customClass?: string
}

export default function BusinessSpeed({ customClass }: BusinessSpeedProps) {
    const componentClass = `BusinessSpeed ${styles.BusinessSpeed} ${customClass ?? ''}`

    return (
        <div className={componentClass}>
            <Row>
                <Col className="featuredImage" lg={6}>
                    <Image
                        className="w-100 h-auto"
                        src={BusinessSpeedImage.src}
                        alt="Casper Labs"
                        width={800}
                        height={800}
                    />
                </Col>
                <Col
                    className="featuredContent position-relative overflow-hidden d-flex flex-column justify-content-center"
                    lg={6}
                >
                    <h2 className="mb-4">
                        Business at the <span className="text-purple">speed</span> of market
                    </h2>
                    <p className="mb-5">
                        Casper Labs is the team behind the development of the Casper Network. It provides services and
                        support for organizations of all sizes, from enterprise to startup. Guided by open source
                        principles, Casper Labs is committed to supporting the next wave of blockchain adoption among
                        businesses and providing developers with a reliable and secure solution.
                    </p>
                    <Link aria-label="Read more" href="/professional-services">
                        <Button variant="secondary">Read more</Button>
                    </Link>
                </Col>
            </Row>
        </div>
    )
}
